import React from 'react';
import tadreamkLogo from '../../../../assets/images/TadReamk_logo_without_bg.png';
import './LoadingWithLogo.css';

export default function LoadingWithLogo({ message = 'Extracting information...' }) {
  return (
    <div className="flex flex-col items-center justify-center space-y-6 py-8">
      {/* Logo with single smooth ring */}
      <div className="relative w-36 h-36">
        {/* Single smooth arc with gradient - slower rotation */}
        <div className="absolute inset-0 rounded-full animate-spin-slow">
          <div className="arc-spinner"></div>
        </div>
        
        {/* Logo in center - smaller to create more distance from ring */}
        <div className="absolute inset-0 flex items-center justify-center p-10">
          <img
            src={tadreamkLogo}
            alt="TadReamk Logo"
            className="w-full h-full object-contain drop-shadow-2xl"
          />
        </div>
      </div>
      
      {/* Loading text */}
      <p className="text-sm font-medium text-violet-200 animate-pulse">
        {message}
      </p>
    </div>
  );
}

